import React from 'react';
import PropTypes from 'prop-types';
import { Row, Card, CardBody, CardTitle } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { faPlug } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Example({ example, child }) {
  return (
    <Card>
      <CardBody>
        <CardTitle>
          {child === undefined && (<Row>
            <Colxx xxs="8">
              <FontAwesomeIcon icon={faPlug} style={{ color: '#9e9e9e' }} />
              <span> </span>
              <IntlMessages
                id="property.example"
                style={{ color: '#9e9e9e' }}
              />
            </Colxx>
          </Row>)}

        </CardTitle>
        <Row>
          <Colxx xxs="12">
            {<p style={{ color: '#9e9e9e' }}>{example}</p>}
          </Colxx>
        </Row>
      </CardBody>
    </Card>
  );
}

Example.propTypes = {
  example: PropTypes.string.isRequired,
};
